/**
 * @license
 * Copyright The Closure Library Authors.
 * SPDX-License-Identifier: Apache-2.0
 */

goog.module('goog.flags');
goog.module.declareLegacyNamespace();

exports.USE_USER_AGENT_CLIENT_HINTS = false;
exports.ASYNC_THROW_ON_UNICODE_TO_BYTE = false;
